// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-nXuw","cardInner":"Card_cardInner__3Yysl","header":"Card_header__pOiOh","content":"Card_content__Y7xUa","purposeContent":"Card_purposeContent__RTjoT"};